<template>
  <v-btn v-on="$listeners" v-bind="$props" depressed class="text-capitalize font-weight-bold">
    <slot></slot>
  </v-btn>
</template>
<script lang="ts">
  import Vue from 'vue';
  import VBtn from 'vuetify/es5/components/VBtn';
  export default Vue.extend({
    name: 'Btn',
    extends: VBtn,
  });
</script>
<style lang="scss" scoped>
  .v-application .v-btn.primary:hover {
    background-color: #6b6b6b !important;
  }
</style>
